
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.687 13.096a13.042 13.042 0 00-9.207-3.598c-6.261 0-11.579 4.224-13.475 9.912a14.375 14.375 0 000 9.19h.009c1.905 5.678 7.213 9.902 13.475 9.902 3.232 0 6.007-.826 8.157-2.286v-.006a11.109 11.109 0 004.797-7.293H24.48v-9.242h22.637c.283 1.605.415 3.245.415 4.876 0 7.3-2.609 13.472-7.148 17.652l.005.003C36.412 45.875 30.953 48 24.48 48A24.003 24.003 0 013.033 34.781a24.02 24.02 0 010-21.553A23.995 23.995 0 0124.48 0a23.066 23.066 0 0116.059 6.244l-6.852 6.852z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h48v48H0z"}})])])])
          )
        }
      }
    